// extracted by mini-css-extract-plugin
export default {"formElement":"formElement_formElement__TLU6L"};